import { render } from "./company-pdf-preview.vue?vue&type=template&id=5d16d0cb&scoped=true"
import script from "./company-pdf-preview.vue?vue&type=script&lang=js"
export * from "./company-pdf-preview.vue?vue&type=script&lang=js"

import "./company-pdf-preview.vue?vue&type=style&index=0&id=5d16d0cb&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d16d0cb"]])

export default __exports__